import { esc } from '../calc/format.js';

/* --------------------------------------------------------------------------
   Rendering
   -------------------------------------------------------------------------- */

export const el = id => document.getElementById(id);

/* Saknar varje artikel i filen inköpspris går bruttovinst och marginal inte
   att räkna fram: vinsten blir hela omsättningen exklusive moms och
   marginalen 100 %. Då visas de inte alls, med den här förklaringen. */
export const NO_COST_TITLE = 'Inköpspris saknas';
export const NO_COST_TEXT  = 'Ingen artikel i filen har inköpspris i artikelregistret, så bruttovinst och marginal går inte att räkna fram.';

export function emptyRow(cols, msg, hint){
  return `<tr><td colspan="${cols}"><div class="empty"><strong>${esc(msg)}</strong>${hint ? esc(hint) : ''}</div></td></tr>`;
}

/* ---- Sorterbara tabeller ---- */
export function sortRows(rows, sort){
  const {key, dir} = sort;
  const m = dir === 'asc' ? 1 : -1;
  return rows.sort((a,b) => {
    const x = a[key], y = b[key];
    if(typeof x === 'string' || typeof y === 'string'){
      return String(x).localeCompare(String(y),'sv') * m;
    }
    return ((x||0) - (y||0)) * m;
  });
}

export function headCell(label, key, sort, cls){
  const active = sort.key === key;
  const arrow = active ? (sort.dir === 'asc' ? '▲' : '▼') : '';
  return `<th class="${cls||''} sortable${active ? ' sorted':''}" data-key="${esc(key)}" tabindex="0" role="button">
    ${esc(label)}<span class="arrow">${arrow}</span></th>`;
}
